import React, { type FC } from 'react'

import { GRID_VARIANT_SMALL, Grid, GridCell } from 'mailup-web-components'

import InputCritType from 'Pages/RecipientsList/components/filters/InputCritType'

import ActionDeleteCriterion from 'Pages/RecipientsList/components/filters/ActionDeleteCriterion'

interface CriterionUndefinedProps {
  index: number
}

const CriterionUndefined: FC<CriterionUndefinedProps> = ({ index }) => {
  return (
    <Grid variant={GRID_VARIANT_SMALL} cols={12}>
      <GridCell span={3}>
        <InputCritType index={index} />
      </GridCell>
      <GridCell span={2}>
        <ActionDeleteCriterion index={index} />
      </GridCell>
    </Grid>
  )
}

export default CriterionUndefined
